import SuccessIcon from './SuccessIcon';

export * from './SuccessIcon';
export default SuccessIcon;
